/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Plugins_Contact_Support_EmailInputs */



/**
* | output |
* | --- |
* | "support@closedcaptioncreator.com" |
*
* @param {Team_Manager_Plugins_Contact_Support_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_plugins_contact_support_email = /** @type {((inputs?: Team_Manager_Plugins_Contact_Support_EmailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Plugins_Contact_Support_EmailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("support@closedcaptioncreator.com")
	if (locale === "de") return /** @type {LocalizedString} */ ("support@closedcaptioncreator.com")
	if (locale === "it") return /** @type {LocalizedString} */ ("support@closedcaptioncreator.com")
	if (locale === "ru") return /** @type {LocalizedString} */ ("support@closedcaptioncreator.com")
	if (locale === "es") return /** @type {LocalizedString} */ ("soporte@closedcaptioncreator.com")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("support@closedcaptioncreator.com")
	if (locale === "ja") return /** @type {LocalizedString} */ ("support@closedcaptioncreator.com")
	if (locale === "hi") return /** @type {LocalizedString} */ ("support@closedcaptioncreator.com")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("support@closedcaptioncreator.com")
	return /** @type {LocalizedString} */ ("support@closedcaptioncreator.com")
});